import { useRouter } from 'next/router'

import DropdownMenu from '@/legacy-src/components/button/DropdownMenu'
import useServices from '@/legacy-src/hooks/useServices'
import { SERVICES_TYPE } from '@/legacy-src/redux/DiagnosisRedux'
import { type ServiceType } from '@/legacy-src/types/GeneralStateType'
import { type TherapistType } from '@/legacy-src/types/TherapistStateType'
import { getTranslate } from '@/legacy-src/utilities/i18n'

type Props = {
  readonly therapist: TherapistType
  readonly className?: string
}

const getItemString = (name?: string, duration?: number) => {
  const { t } = getTranslate()
  if (!name || !duration) return ''

  return `${name} (${t('general.appointments.duration', { duration })})`
}

const ServiceDropdownMultibooking: React.FC<Props> = ({ className, therapist }) => {
  const router = useRouter()
  const { selectedService, services } = useServices()

  const handleOnChangeService = (option: ServiceType) =>
    router.push(
      {
        pathname: router.pathname,
        query: { ...router.query, service: option.id },
      },
      undefined,
      { shallow: true },
    )

  const mainItem = {
    text: getItemString(selectedService?.name, selectedService?.duration),
    icon: selectedService?.iconName ? selectedService.iconName : 'user',
  }

  const dropdownListItems = (therapist?.services || []).reduce((acc, serviceId) => {
    const service = services?.find((service) => service.id === serviceId)
    if (service && service.type !== SERVICES_TYPE.INSTANT && service.type !== SERVICES_TYPE.COUNSELLING) {
      acc.push({
        text: getItemString(service.name, service.duration),
        value: service,
        icon: service.iconName || 'user',
        onClick: handleOnChangeService,
      })
    }
    return acc
  }, [])

  return (
    <DropdownMenu
      dataTestId="service-select"
      className={className}
      mainItem={mainItem}
      listItems={dropdownListItems}
      align="center"
    />
  )
}

export default ServiceDropdownMultibooking
